import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[locale]/(web)/usd1-points/page.tsx");
